/**
 * Eluve tables that have a one-way FHIR mirror. Extend here first.
 *
 * Lives in this shared lib rather than in `@eluve/fhir-mirror` because the
 * vocabulary has three consumers that can't all reach a backend lib: the
 * mirror itself, the ts-rest admin contract (bundled into the browser), and
 * the admin page's entity list. One definition, no drift.
 */
export const FHIR_MIRROR_ENTITIES = [
  'location',
  'practitioner',
  'patient',
  // location_users assignments → per-(user, location) PractitionerRoles;
  // compound id `<userId>:<locationId>` (see userLocationIdentifierValue).
  'practitioner-role',
] as const;

export type FhirMirrorEntity = (typeof FHIR_MIRROR_ENTITIES)[number];

/**
 * FHIR resources the reverse (FHIR→eluve) sync carries, and therefore the ones
 * its admin backfill can re-drive. Here for the same reason as the list above:
 * the contract that names them is bundled into the browser.
 *
 * Deliberately a separate vocabulary from FHIR_MIRROR_ENTITIES — the two
 * directions do not cover the same set, and `patient` appearing in both is a
 * coincidence of that overlap, not a shared meaning.
 */
export const REVERSE_SYNC_RESOURCES = ['appointment', 'patient'] as const;

export type ReverseSyncResource = (typeof REVERSE_SYNC_RESOURCES)[number];
